import React, { useState, useEffect, useCallback, useRef } from 'react';
import "./styleEditEmpInfo.css";
import profile from "../../../assets/images/profile.png";
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { setAllEmployee, setEditForm, setEmpInfo, setIsClosureKey, setSelf, setUpdateEmp } from '../../../erpStore/actions';
import { toast } from 'react-toastify';
// import { useDropzone } from "react-dropzone";
import Select from "react-select";
import Cropper from 'react-easy-crop';
import Multiselect from 'multiselect-react-dropdown';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { useNavigate } from 'react-router';
import { Calendar } from "primereact/calendar";
import moment from 'moment'


function EditEmpInfo(props) {
    const [selfData, setSelfData] = useState(props.props);
    const empInfo = useSelector((state) => state.data.empInfo);
    const [empObj, setEmpObj] = useState(empInfo);
    const isClosureKey = useSelector((state) => state.data.isClosureKey);
    const [edit, setEdit] = useState(useSelector((state) => state.data.isClosureKey));
    const apiUrl = useSelector((state) => state.data.apiUrl);
    const dispatch = useDispatch();
    const stringHeaders = window.localStorage.getItem('myHeaders');
    const storedHeaders = JSON.parse(stringHeaders);
    const [roleList, setRoleList] = useState();
    const selfInfo = useSelector((state) => state.data.selfData);
    const [status, setStatus] = useState(empObj.empStatus);
    const [isError, setIsError] = useState();
    const [profileView, setProfileView] = useState(false);
    const allEmployee = useSelector((state) => state.data.allEmployee)
    const [tempImg, setTempImg] = useState("");

    const [joiningDateFlag, setJoiningDateFlag] = useState(false)
    const [joiningDate, setJoiningDate] = useState(empObj.empJoiningDate)
    const joiningDateRef = useRef(null)

    const [dobDateFlag, setDobDateFlag] = useState(false)
    const [dobDate, setDobDate] = useState(null)
    const dobRef = useRef(null)

    const [cardId, setCardId] = useState(empInfo.cardId)

    const navigate = useNavigate()
    const [loaderBtn, setLoaderBtn] = useState(false)
    // const [formData, setFormData] = useState();
    const [isChange, setIsChange] = useState();
    const [role, setRole] = useState({
        value: empInfo.role && empInfo.role.length > 0 ? empInfo.role[0].roleId : "",
        label: empInfo.role && empInfo.role.length > 0 ? empInfo.role[0].roleName : "",
        empId: empInfo.empId
    });
    const [keyData, setKeydata] = useState(
        {
            userId: selfData.userId,
            userKey: empObj.encryptedKey,
            password: ""
        }
    );
    const [departmentList, setDepList] = useState();
    const [departmentName, setDepartmentName] = useState({
        value: empInfo.department.departmentId,
        label: empInfo.department.departmentName,
        empId: empInfo.empId
    });
    const [designation, setDesignation] = useState({
        value: empInfo.designation.designationId,
        label: empInfo.designation.designation,
        empId: empInfo.empId
    });
    const [designationList, setDesignationList] = useState();
    const [authorityList, setAuthorityList] = useState();
    const [authority, setAuthority] = useState();

    const fileToBlob = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = () => {
                resolve(new Blob([reader.result], { type: file.type }));
            };

            reader.onerror = (error) => {
                reject(error);
            };

            reader.readAsArrayBuffer(file);
        });
    };

    useEffect(() => {
        if (empObj.empStatus !== null) {
            setStatus(empObj.empStatus)
        }
        setSelfData(props.props)
        axios.get(`${apiUrl}employee/department/get/all`, {
            headers: storedHeaders
        })
            .then((response) => {
                const modifiedDeptList = response.data.map(department => ({
                    value: parseInt(department.departmentId),
                    label: department.departmentName,
                    empId: parseInt(props.props.empId)
                }))
                setDepList(modifiedDeptList)
            })
            .catch((error) =>{})
        axios.get(`${apiUrl}employee/role/all`, {
            headers: storedHeaders
        })
            .then((response) => {
                const modifiedDeptList = response.data.map(role => ({
                    value: parseInt(role.roleId),
                    label: role.roleName,
                    empId: parseInt(props.props.empId),
                    roleLevel: role.roleLevel,
                    role: role.role
                }))
                setRoleList(modifiedDeptList)
            })
            .catch((error) => {})

        const modifiedAuthList = empObj && empObj.reportingAuthorities.map(authority => ({
            value: parseInt(authority.empId),
            label: authority.empFullName,
            empId: parseInt(props.props.empId),
            key: authority.empFullName,
        }))
        setAuthority(modifiedAuthList)
        if (empObj && empObj.department && empObj.department.departmentId) {
            axios.get(`${apiUrl}employee/designation/all`, {
                headers: storedHeaders
            })
                .then(async (response) => {
                    const modifiedDeptList = await response.data.map(designation => ({
                        value: parseInt(designation.designationId),
                        label: designation.designation,
                        empId: parseInt(props.props.empId)
                    }))
                    setDesignationList(modifiedDeptList)
                })
                .catch((error) => {
                })

        }
        if ((empObj && empObj.department && empObj.department.departmentId) && (empObj.role && empObj.role.length > 0)) {

            axios.get(`${apiUrl}employee/get/higher/authority?role=${empObj.role[0].roleId}&department=${empObj.department.departmentName}`, {
                headers: storedHeaders
            })
                .then((response) => {
                    const modifiedAuthList = response.data.map(emp => ({
                        value: parseInt(emp.empId),
                        label: emp.empFullName,
                        empId: parseInt(props.props.empId),
                        key: emp.empFullName
                    }))
                    setAuthorityList(modifiedAuthList)
                })
                .catch((error) => {
                })

        }
    }, []);

    const [src, setSrc] = useState(null);
    const [crop, setCrop] = useState({ unit: '%', width: 100, aspect: 1 / 1 });
    const [croppedImageUrl, setCroppedImageUrl] = useState(null);
    const imageRef = useRef(null);
    const [fileUrl, setFileUrl] = useState(null); // New state variable

    const onSelectFile = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            const reader = new FileReader();
            reader.addEventListener('load', () => setSrc(reader.result));
            reader.readAsDataURL(e.target.files[0]);
        }
    };

    const onImageLoaded = (image) => {
        imageRef.current = image;
    };

    const onCropComplete = useCallback((crop) => {
        makeClientCrop(crop);
    }, []);

    const onCropChange = useCallback((crop, percentCrop) => {
        // You could also use percentCrop:
        // setCrop(percentCrop);
        setCrop(crop);
    }, []);

    const [imgDataUrl, setImgDataUrl] = useState();
    const makeClientCrop = async (crop) => {
        if (imageRef.current && crop.width && crop.height) {
            const croppedImageUrl = await getCroppedImg(
                imageRef.current,
                crop,
                'newFile.jpeg'
            );
            setCroppedImageUrl(croppedImageUrl);
            blobUrlToDataUrl(croppedImageUrl, function (dataUrl) {
                setImgDataUrl(dataUrl)
                // Now you can use the dataUrl as a regular image URL
            });

        }
    };
    function blobUrlToDataUrl(blobUrl, callback) {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', blobUrl, true);
        xhr.responseType = 'blob';
        xhr.onload = function () {
            if (xhr.status === 200) {
                const blob = xhr.response;
                const reader = new FileReader();
                reader.onload = function () {
                    const dataUrl = reader.result;
                    callback(dataUrl);
                };
                reader.readAsDataURL(blob);
            }
        };
        xhr.send();
    }
    const [isChangeImg, setIsChangeImg] = useState(false)
    const [blobFile, setBlobfile] = useState()
    const getCroppedImg = (image, crop, fileName) => {
        const canvas = document.createElement('canvas');
        const pixelRatio = window.devicePixelRatio;
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        const ctx = canvas.getContext('2d');

        canvas.width = crop.width * pixelRatio * scaleX;
        canvas.height = crop.height * pixelRatio * scaleY;

        ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        ctx.imageSmoothingQuality = 'high';

        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width * scaleX,
            crop.height * scaleY
        );

        return new Promise((resolve, reject) => {
            canvas.toBlob(
                (blob) => {
                    if (!blob) {
                        return;
                    }
                    blob.name = fileName;
                    window.URL.revokeObjectURL(fileUrl); // Use fileUrl from state
                    const newFileUrl = window.URL.createObjectURL(blob); // Store new URL in a variable
                    setBlobfile(blob)
                    setFileUrl(newFileUrl); // Update state with new URL
                    resolve(newFileUrl);
                    setIsChangeImg(true)
                },
                'image/jpeg',
                1
            );
        });
    };


    const handleDesignation = (e) => {
        setIsChange(true)
        setEmpObj({
            ...empObj,
            designation: {
                ...empObj.designation,
                designationId: parseInt(e.value.toString()),
                designation: e.label
            },
        });
        setDesignation(e)
    }
    const handleAuthority = (e) => {
        setIsChange(true)
        let auth = [];
        for (let i = 0; i < e.length; i++) {
            auth.push({
                empId: e[i].value,
                empFullName: e[i].label
            });
        }
        setEmpObj({
            ...empObj,
            reportingAuthorities: auth
        });
        setAuthority(e)
    }
    const cancelFromEdit = () => {
        dispatch(setIsClosureKey(false))
        const unloadElement = document.getElementById('unloadElement');
        if (unloadElement) {
            unloadElement.classList.add('fade-out');
        }
        setTimeout(function () {
            dispatch(setEditForm(false))
        }, 1000)
    }

    const handleNotificationDrawer = () => {

        if (document.querySelector(".edit-employee").classList[1] === 'active') {
            document.querySelector(".edit-employee").classList.toggle("active")
            document.querySelector(".edit-employeefom-container").classList.toggle("active")
        }
        document.querySelector(".Notification_Main_Container").classList.toggle("active")
    }
    const handleCancelEdit = () => {
        if (isChange) {
            var userConfirmed = window.confirm("Do you want to Cancel?");
            if (userConfirmed) {
                setEdit(false)
                setEmpObj(empInfo)
                setIsChange(false)
            }
            return
        }
        setEdit(false)
        setEmpObj(empInfo)
    }
    const handleNameChange = (e) => {
        setIsChange(true)
        if (isValidName(e.target.value) || e.target.value === "") {
            setEmpObj({
                ...empObj,
                empFullName: e.target.value,
            });
        }
    };
    const handlePrimaryMobile = (e) => {
        const inputValue = e.target.value;
        if (e.nativeEvent.data === '+' || e.nativeEvent.data === '-') {
            return
        }
        if (e.target.value.length > 10) {
            return
        }
        setIsChange(true);
        setEmpObj({
            ...empObj,
            empMobile1: inputValue,
        });

    }
    const handleSecondMobile = (e) => {
        if (e.target.value.length > 10) {
            return
        }
        setIsChange(true)
        setEmpObj({
            ...empObj,
            empMobile2: e.target.value,
        });
    }
    const handlePrimaryEmail = (e) => {
        setIsChange(true)
        document.getElementById("officialEmail").setAttribute('style', 'border: 1px solid rgba(38, 50, 56, 0.4)')
        setEmpObj({
            ...empObj,
            empEmailOfficial: e.target.value,
        });
    }
    const handleSecondaryEmail = (e) => {
        setIsChange(true)
        document.getElementById("persnolEmail").setAttribute('style', 'border: 1px solid rgba(38, 50, 56, 0.4)')
        setEmpObj({
            ...empObj,
            empEmailPersonal: e.target.value,
        });
    }
    const handleBloodGroup = (e) => {
        setIsChange(true)
        setEmpObj({
            ...empObj,
            empBloodGroup: e.target.value,
        });
    }
    const handleDob = (e) => {
        setIsChange(true)
        setEmpObj({
            ...empObj,
            empDOB: e.target.value,
        });
    }

    const handleAddress = (e) => {
        setIsChange(true)
        setEmpObj({
            ...empObj,
            empAddress: e.target.value,
        });
    }

    const handleCardId = (e) => {
        setIsChange(true)
        setCardId(e.target.value)
        setEmpObj({
            ...empObj,
            cardId: e.target.value
        })
    }
    const handleStatus = (e) => {
        setIsChange(true)
        setStatus(e.target.value)
        setEmpObj({
            ...empObj,
            empStatus: e.target.value,
        });
    }
    function isValidName(name) {
        const regex = /^[a-zA-Z\s]+$/;
        return regex.test(name);
    }
    const handleJoiningDate = (e) => {
        setIsChange(true)
        setEmpObj({
            ...empObj,
            empJoiningDate: e.target.value,
        });
    }
    function validateIndianMobileNumber(number) {
        const indianMobileNumberPattern = /^(\+91[\-\s]?)?[0]?(91)?[6789]\d{9}$/;
        return indianMobileNumberPattern.test(number);
    }
    function validateEmail(email) {
        // Regular expression pattern for email validation
        var pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})?$/;
        // var pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;


        // Check if the provided email matches the pattern
        return pattern.test(email);
    }


    const handleOfficeLocation = (e) => {
        setIsChange(true)
        setEmpObj({
            ...empObj,
            empOfficeLocation: e.target.value,
        });
    }
    function validateBloodGroup(bloodGroup) {
        const bloodGroupPattern = /^(A|B|AB|O|a|b|ab|o)[+-]$/;
        return bloodGroupPattern.test(bloodGroup);
    }
    const handleDepartment = async (e) => {
        setAuthority([])
        setIsChange(true)
        setEmpObj({
            ...empObj,
            designation: null
        });
        setDesignation({
            "value": 0,
            "label": "",
            "empId": 8
        })
        setEmpObj({
            ...empObj,
            department: {
                ...empObj.department,
                departmentId: parseInt(e.value),
                departmentName: e.label
            },
        }, []);
        setDepartmentName(e)
        axios.get(`${apiUrl}employee/designation/all`, {
            headers: storedHeaders
        })
            .then(async (response) => {
                const modifiedDeptList = await response.data.map(designation => ({
                    value: parseInt(designation.designationId),
                    label: designation.designation,
                    empId: parseInt(props.props.empId)
                }))
                setDesignationList(modifiedDeptList)

            })
            .catch((error) => {
            })
        setEmpObj(prevState => ({
            ...prevState,
            designation: null
        }));

        if (departmentName && departmentName.label) {
            axios.get(`${apiUrl}employee/get/higher/authority?role=${empObj ? empObj.role[0].roleId : null}&department=${e.label}`, {
                headers: storedHeaders
            })
                .then((response) => {
                    const modifiedAuthList = response.data.map(emp => ({
                        value: parseInt(emp.empId),
                        label: emp.empFullName,
                        empId: parseInt(props.props.empId),
                        key: emp.empFullName
                    }))
                    setAuthorityList(modifiedAuthList)
                })
                .catch((error) => {
                })
        } else {
            toast.error("Please Select Department", { toastId: 'error', autoClose: 2000 });
        }
    }

    const handleRoleChange = (e) => {
        setIsChange(true)
        let rl = [];
        for (let i = 0; i < e.length; i++) {
            rl.push({
                roleId: e[i].value,
                role: e[i].role,
                roleName: e[i].label,
                roleLevel: e[i].roleLevel
            });
        }
        setEmpObj({
            ...empObj,
            role: [{
                roleId: e.value,
                role: e.role,
                roleName: e.label,
                roleLevel: e.roleLevel
            }]
        });
        setRole(e)
        if (departmentName && departmentName.label) {
            axios.get(`${apiUrl}employee/get/higher/authority?role=${e.value}&department=${departmentName.label}`, {
                headers: storedHeaders
            })
                .then((response) => {
                    setAuthority([])
                    const modifiedAuthList = response.data.map(emp => ({
                        value: parseInt(emp.empId),
                        label: emp.empFullName,
                        empId: parseInt(props.props.empId),
                        key: emp.empFullName
                    }))
                    setAuthorityList(modifiedAuthList)
                })
                .catch((error) => {
                })
        } else {
            toast.error("Please Select Department", { toastId: 'error', autoClose: 2000 });
        }
    }


    useEffect(() => {
        setAuthorityList(authorityList)
    }, [authorityList])

    const handleUpdateProfile = async () => {
        setLoaderBtn(true)
        let isError = false

        if (isChangeImg) {
            const blob = blobFile
            const formData = new FormData();
            formData.append('file', blob, 'cropped-image.png'); // Change 'croppedImage' to 'file'
            try {

                const response = await axios.post(
                    `${apiUrl}attach/files/emp/image/add?userId=${empObj.userId}`,
                    formData,
                    {
                        headers: {
                            Authorization: storedHeaders.Authorization,
                            'Content-Type': 'multipart/form-data',
                        },
                    }
                )
                if (response && response.request.status === 200) {
                    isError = false
                }

            }
            catch (err) {
                toast.error("Profile Photo Not Updated", { autoClose: 2000 })
                isError = true
            }
        }

        if (isError) {
            setLoaderBtn(false)
            return
        }

        if (!empObj.department) {
            toast.error("Please select designation", { autoClose: 2000 })
            setIsError(true)
            setLoaderBtn(false)
            return
        }
        if (empObj?.role[0].roleId !== 1 && (empObj?.reportingAuthorities?.length === 0 || authority?.length === 0)) {
            toast.error("Please select Authority", { autoClose: 2000 })
            setIsError(true)
            setLoaderBtn(false)
            return
        }
        if (!empObj.designation) {
            toast.error("Please select designation", { autoClose: 2000 })
            setIsError(true)
            setLoaderBtn(false)
            return
        }
        if ((empObj.empEmailOfficial && empObj.empEmailOfficial !== "") && !validateEmail(empObj.empEmailOfficial)) {
            document.getElementById("officialEmail").setAttribute('style', 'border:1px solid red')

        }
        if (!empObj.empEmailPersonal && empObj.empEmailPersonal === '' && !validateEmail(empObj.empEmailPersonal)) {
            document.getElementById("persnolEmail").setAttribute('style', 'border:1px solid red')
        }
        if (empObj.empFullName === "") {
            toast.error("Enter Full Name", { autoClose: 2000 })
            setIsError(true)
            setLoaderBtn(false)
            return
        }
        if (empObj.empJoiningDate === "" || !empObj.empJoiningDate) {
            toast.error("Please Select employee joining date", { autoClose: 2000 })
            setIsError(true)
            setLoaderBtn(false)
            return
        }
        if (!validateIndianMobileNumber(empObj.empMobile1)) {
            toast.error("Enter Valid Primary Mobile Number", { autoClose: 2000 })
            setIsError(true)
            setLoaderBtn(false)
            return
        }
        if (empObj.empMobile2 && empObj.empMobile2 !== "" && !validateIndianMobileNumber(empObj.empMobile2)) {
            toast.error("Enter Valid Secondary Mobile Number", { autoClose: 2000 })
            setIsError(true)
            setLoaderBtn(false)
            return
        }
        if ((empObj.empEmailOfficial && empObj.empEmailOfficial !== "") && !validateEmail(empObj.empEmailOfficial)) {
            toast.error("Enter Valid official email", { autoClose: 2000 })
            setIsError(true)
            setLoaderBtn(false)
            return
        }

        if ((empObj.empEmailPersonal && empObj.empEmailPersonal !== "") && !validateEmail(empObj.empEmailPersonal)) {
            toast.error("Enter Valid Personal email", { autoClose: 2000 })
            setIsError(true)
            setLoaderBtn(false)
            return
        }
        if (!validateEmail(empObj.empEmailPersonal)) {
            toast.error("Enter Valid personal email", { autoClose: 2000 })
            setIsError(true)
            setLoaderBtn(false)
            return
        }
        if (empObj.empOfficeLocation === "") {
            toast.error("Please enter office location", { autoClose: 2000 })
            setIsError(true)
            setLoaderBtn(false)
            return
        }
        if (!validateBloodGroup(empObj.empBloodGroup) && empObj.empBloodGroup && empObj.empBloodGroup !== "") {
            toast.error("Enter Valid Blood Group", { autoClose: 2000 })
            setIsError(true)
            setLoaderBtn(false)
            return
        }

        const url = `${apiUrl}employee/update`;
        axios.put(url, empObj, {
            headers: storedHeaders,
        })
            .then(response => {
                // dispatch(setEmpInfo(response.data));
                // dispatch(setSelf(response.data));

                const updatedAllEmployee = allEmployee.map((employee, index) => {
                    if (employee.empId === empObj.empId) {
                        return empObj; // Replace the old employee object with the updated one
                    } else {
                        return employee;
                    }
                });
                if (selfInfo.empId === empObj.empId) {
                    dispatch(setSelf(empObj))
                }
                dispatch(setAllEmployee(updatedAllEmployee));

                toast.success(`Employee details updated successfully`, { toastId: 'success', autoClose: 2000 });
                dispatch(setUpdateEmp(response.data));
                setLoaderBtn(false)

                const unloadElement = document.getElementById('unloadElement');
                if (unloadElement) {
                    unloadElement.classList.add('fade-out');
                }
                setTimeout(() => {
                    dispatch(setEditForm(false));
                }, 1000);
            })
            .catch(error => {
                setLoaderBtn(false)
                if (error.response && error.response && error.response.status === 500) {
                    navigate("/server-error")
                }
                if (error.response && error.response && error.response.status === 409) {
                    toast.warning(`${error.response.data.message}`)
                }
                if (error.response && error.response && error.response.status === 422) {
                    toast.error("Employee is Inactive, can't Change details", { toastId: 'success', autoClose: 2000 });
                }
            });
    }
    const handleGmailKey = (e) => {
        setKeydata({
            ...keyData,
            userKey: e.target.value.replace(/\s/g, ""),
        });
    }
    const handlePass = (e) => {
        setKeydata({
            ...keyData,
            password: e.target.value,
        });
    }

    const submitKey = async () => {

        // if (keyData.userKey.length !== 16) {
        //     toast.error("Please Fill Correct 16 digit key", { toastId: 'success', autoClose: 2000 });
        //     return
        // }

        if(keyData.userKey === ''){
            toast.error("Please Fill Gmail key", { autoClose: 2000 });
            return
        }

        if (keyData.password === "") {
            toast.error("Please Fill Correct password", { autoClose: 2000 });
            return
        }

        axios.put(`${apiUrl}email/cred/update`, keyData, {
            headers: storedHeaders
        })
            .then((resp) => {
                if (resp.data) {
                    toast.success("Updated Successfully", { toastId: 'success', autoClose: 2000 });
                    dispatch(setIsClosureKey(false))
                    setKeydata({
                        ...keyData,
                        userKey: "",
                    });
                    setKeydata({
                        ...keyData,
                        password: "",
                    });
                } else {
                    toast.error("Please Fill Correct 16 digit key", { toastId: 'success', autoClose: 2000 });
                }
            })
            .catch((err) => {
                if (err.response.data.status === 401) {
                    toast.error("Enter valid password", { toastId: 'success', autoClose: 2000 });
                }
            })
    }

    useEffect(() => {
        function handleOutsideClick(event) {
            if (joiningDateRef && joiningDateRef.current && !joiningDateRef.current.contains(event.target)) {
                setJoiningDateFlag(false)
            } else if (dobRef && dobRef.current && !dobRef.current.contains(event.target)) {
                setDobDateFlag(false)
            }
        }
        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick)
        }
    }, [])


    return (
        <div className='edit-employee' onClick={() => setProfileView(false)}>
            {edit ?
                <div className='edit-employeefom-container' id='unloadElement'>
                    <div className="edit-employee-scroll-container">
                        <div className='dash-header'>
                            <div className='dash-header-container'>
                                <div className='dashHead-left-content'>
                                </div>
                                <div className='dashHead-right-content active'>
                                    <img className='profileImg' src={selfInfo.empImg ? selfInfo.empImg : profile} alt='/' />
                                    <p className='profileName'>{props.props.empFullName}</p>
                                    <svg width="32" height="33" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M6.10305 0.0128568L6.08027 0.000677966C5.99553 0.000677966 5.91098 0.000677967 5.82725 0C5.50742 0.125153 5.38125 0.362911 5.41313 0.69835C5.41818 0.751721 5.4168 0.805763 5.41543 0.859865C5.41422 0.907526 5.413 0.955249 5.41618 1.00258C5.42228 1.09552 5.39515 1.13147 5.29543 1.14809C3.54023 1.44045 2.20187 2.9908 2.16863 4.77177C2.16199 5.12331 2.16308 5.47485 2.16418 5.82639C2.16471 5.99514 2.16523 6.16388 2.1649 6.33263C2.16388 6.93432 2.03805 7.5065 1.76129 8.04306C1.54355 8.46499 1.25254 8.82892 0.895392 9.14231C0.486015 9.50081 0.420555 10.056 0.735304 10.4603C0.946607 10.732 1.23219 10.8358 1.56932 10.8354C3.84334 10.8341 6.11737 10.8342 8.39139 10.8344L10.3382 10.8344L10.3527 10.8344C10.3817 10.8345 10.4106 10.8345 10.4396 10.8331C11.0145 10.8022 11.411 10.3528 11.3615 9.78232C11.3364 9.49471 11.176 9.28544 10.967 9.09788C10.2426 8.44735 9.82436 7.63538 9.76399 6.6623C9.74285 6.32142 9.74376 5.97907 9.74467 5.63665C9.74528 5.40772 9.74589 5.17875 9.73991 4.95018C9.73279 4.67681 9.72092 4.39835 9.66529 4.13176C9.33935 2.56615 8.16413 1.43129 6.58733 1.1447C6.51136 1.13079 6.49033 1.1006 6.49169 1.0287C6.49508 0.859794 6.4961 0.690209 6.49033 0.521303C6.48253 0.296773 6.36789 0.140754 6.16676 0.045787C6.14529 0.035552 6.12419 0.0242147 6.10305 0.0128568Z" fill="#FF8402" />
                                        <path fillRule="evenodd" clipRule="evenodd" d="M1.94262 0.600171C0.731109 1.84831 0.087704 3.34235 0.00528583 5.07822C0.00528583 5.11598 0.00396383 5.15389 0.0026421 5.19179C-0.000322873 5.27683 -0.00328649 5.36182 0.00867773 5.44487C0.0449689 5.69721 0.25695 5.88002 0.503865 5.89121C0.771131 5.90342 0.996678 5.743 1.05773 5.48455C1.07558 5.40811 1.07737 5.32708 1.07915 5.24693C1.07953 5.22965 1.07991 5.21238 1.08045 5.19524C1.1103 4.27948 1.33788 3.41799 1.77948 2.61416C2.03352 2.15153 2.34793 1.73401 2.7183 1.35855C2.85363 1.22153 2.92926 1.0611 2.89535 0.86608C2.85736 0.647994 2.73085 0.497063 2.51717 0.431604C2.29095 0.362413 2.10305 0.434996 1.94262 0.600171ZM11.9034 5.07589C11.9034 5.11271 11.9047 5.14972 11.9059 5.18674C11.9088 5.26842 11.9116 5.35017 11.9007 5.42999C11.8613 5.7193 11.6202 5.90754 11.3288 5.89092C11.0561 5.87532 10.8329 5.64671 10.8296 5.36249C10.8221 4.73198 10.7292 4.11706 10.5257 3.51944C10.2628 2.74783 9.85139 2.06543 9.29482 1.47052C9.27796 1.45245 9.26085 1.4346 9.24373 1.41673C9.20818 1.37963 9.17255 1.34245 9.13914 1.30331C8.94615 1.07743 8.96006 0.759964 9.16966 0.558497C9.37893 0.35737 9.70792 0.343802 9.91312 0.55714C10.1556 0.809821 10.3917 1.07234 10.5999 1.35317C11.4187 2.45717 11.843 3.70395 11.9034 5.07589ZM7.92396 11.3788H3.97468C4.11679 12.2183 4.94877 13.0597 6.07956 12.9967C6.97633 12.9465 7.92362 12.1175 7.92396 11.3788Z" fill="#263238" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div className='editEmp-container'>
                            <div className='emp-edit-container'>
                                <div className='emp-edit active'>
                                    <svg width="12" height="12" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.30003 2.20612L7.5445 1.16119L4.68624 5.47621L6.44069 6.52011L9.30003 2.20612ZM4.41853 6.80306L4.37977 7.78343L5.29521 7.32432L6.14653 6.89852L4.45367 5.89033L4.41853 6.80306ZM9.76844 0.61864L8.85083 0.0716229C8.73985 0.0056241 8.60576 -0.0158966 8.47805 0.0117925C8.35033 0.0394816 8.23945 0.114114 8.16977 0.21928L7.80751 0.76458L9.56195 1.80917L9.92421 1.26455C10.0691 1.04478 10.0003 0.755308 9.76844 0.617953V0.61864ZM8.33206 8.79814C8.33206 8.89257 8.25056 8.96984 8.15093 8.96984H1.26792C1.21988 8.96984 1.17381 8.95175 1.13984 8.91955C1.10587 8.88735 1.08679 8.84368 1.08679 8.79814V2.27377C1.08679 2.22823 1.10587 2.18456 1.13984 2.15236C1.17381 2.12017 1.21988 2.10208 1.26792 2.10208H6.06574L6.74825 1.07191H1.26792C0.568754 1.07191 0 1.61103 0 2.27377V8.79814C0 9.46088 0.568754 10 1.26792 10H8.15093C8.8501 10 9.41886 9.46088 9.41886 8.79814V3.31664L8.33206 4.95666V8.79917V8.79814Z" fill="#FF8402" />
                                        <path d="M8.33207 8.7985C8.33207 8.89293 8.25056 8.97019 8.15093 8.97019H1.26792C1.21988 8.97019 1.17381 8.9521 1.13984 8.9199C1.10587 8.8877 1.08679 8.84403 1.08679 8.7985V2.27412C1.08679 2.22859 1.10587 2.18492 1.13984 2.15272C1.17381 2.12052 1.21988 2.10243 1.26792 2.10243H6.06574L6.74825 1.07227H1.26792C0.568754 1.07227 0 1.61138 0 2.27412V8.7985C0 9.46123 0.568754 10.0004 1.26792 10.0004H8.15093C8.8501 10.0004 9.41886 9.46123 9.41886 8.7985V3.31699L8.33207 4.95701V8.79953V8.7985Z" fill="#263238" />
                                    </svg>
                                    Edit Info
                                </div>
                            </div>
                            <div className='profile-photo-container'>
                                <img src={empObj.empImg ? empObj.empImg : profile} alt='profile-pic-main' />
                                <input className='profile-img-upload' value={tempImg} type="file" accept="image/*" onChange={onSelectFile} />
                                {empObj.empImg ? null : <svg width="30" height="27" viewBox="0 0 30 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.06258 4.06604C8.14638 5.19271 7.66354 6.9068 8.34524 9.40638C8.43302 9.72824 8.35452 10.0727 8.13593 10.3247C7.91735 10.5767 7.58748 10.7032 7.25644 10.6618C3.80125 10.2299 2.09859 12.3323 2.00423 14.2194C1.956 15.184 2.31454 16.1208 3.09991 16.7772C3.88575 17.434 5.21565 17.9039 7.27005 17.6756C7.81895 17.6146 8.31337 18.0102 8.37436 18.5591C8.43535 19.108 8.03982 19.6024 7.49091 19.6634C5.04531 19.9351 3.1252 19.405 1.81729 18.3118C0.508916 17.2182 -0.0700432 15.6549 0.00672612 14.1196C0.146054 11.333 2.40232 8.71891 6.13405 8.60907C5.77442 6.21717 6.32625 4.26098 7.51088 2.80421C8.87725 1.12394 10.9658 0.255973 13.031 0.0494606C15.0934 -0.156785 17.2754 0.280538 18.9103 1.38859C20.2527 2.29843 21.2154 3.66299 21.3934 5.40822C23.5564 5.05382 25.3445 5.54585 26.6641 6.65361C28.1999 7.94293 28.935 9.92905 29.0048 11.8838C29.0748 13.8417 28.4854 15.9087 27.1911 17.44C25.8671 19.0065 23.852 19.9503 21.27 19.6634C20.7211 19.6024 20.3256 19.108 20.3866 18.5591C20.4476 18.0102 20.942 17.6146 21.4909 17.6756C23.4089 17.8887 24.7689 17.2075 25.6636 16.149C26.5881 15.0553 27.0612 13.4973 27.0061 11.9552C26.9509 10.4099 26.3736 9.02106 25.3781 8.18539C24.4224 7.38302 22.9159 6.95289 20.6678 7.62732C20.344 7.72447 19.993 7.65142 19.7348 7.43315C19.4767 7.21487 19.3463 6.88093 19.3882 6.54546C19.5861 4.96215 18.9213 3.81214 17.7882 3.04415C16.6105 2.24596 14.9175 1.87078 13.23 2.03954C11.5451 2.20802 10.0087 2.90255 9.06258 4.06604ZM13.7558 9.88863C14.121 9.59645 14.64 9.59645 15.0052 9.88863L20.0052 13.8886C20.4364 14.2336 20.5064 14.8629 20.1613 15.2942C19.8163 15.7255 19.187 15.7954 18.7558 15.4504L15.3805 12.7501V25.6695C15.3805 26.2218 14.9328 26.6695 14.3805 26.6695C13.8282 26.6695 13.3805 26.2218 13.3805 25.6695V12.7501L10.0052 15.4504C9.57391 15.7954 8.94462 15.7255 8.59961 15.2942C8.2546 14.8629 8.32452 14.2336 8.75578 13.8886L13.7558 9.88863Z" fill="#263238" />
                                </svg>
                                }
                                <div><span style={{ color: 'rgba(255, 132, 2, 1)' }}>Browse file</span></div>
                            </div>

                            <div className='active-status-dropdown'>
                                <select name="empStatus" value={status} id="empStatus" style={{ background: status === "ACTIVE" ? "rgba(1, 159, 55, 0.15)" : "rgba(202, 3, 3, 0.15)" }} onChange={handleStatus} disabled={selfData.role[0].roleLevel === 1 || selfInfo.role[0].roleLevel === 2 ? false : true}>
                                    <option value="ACTIVE" style={{ background: "rgb(217 241 225);" }}>ACTIVE</option>
                                    <option value="INACTIVE" style={{ background: "rgb(247 217 217)" }}>INACTIVE</option>
                                </select>
                            </div>
                        </div>
                        <div className='emp-form'>{
                            selfInfo.empId === empObj.empId ?
                                <div className='emp-info-slot2 key-gmail'>
                                    <div className='slot-part'>
                                        <label>*16 Digit gmail key</label>
                                        <input value={keyData.userKey} onChange={handleGmailKey} type='text' placeholder='-' autoComplete="off"></input>
                                        {/* {isClosureKey ? <div className='key-msg'>*Paste here 16 digit key and Send</div> : null */}

                                    </div>
                                    <div className='slot-part key-pass'>
                                        <label>ERP Password</label>
                                        <input value={keyData.password} onChange={handlePass} type='password' pla
                                            ceholder='Enter your password' autoComplete='off'></input>
                                    </div>
                                    <div className='key-submit-button' onClick={submitKey}>
                                        Send
                                        <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1 3.5C0.723858 3.5 0.5 3.72386 0.5 4C0.5 4.27614 0.723858 4.5 1 4.5V3.5ZM11.3536 4.35355C11.5488 4.15829 11.5488 3.84171 11.3536 3.64645L8.17157 0.464466C7.97631 0.269204 7.65973 0.269204 7.46447 0.464466C7.2692 0.659728 7.2692 0.976311 7.46447 1.17157L10.2929 4L7.46447 6.82843C7.2692 7.02369 7.2692 7.34027 7.46447 7.53553C7.65973 7.7308 7.97631 7.7308 8.17157 7.53553L11.3536 4.35355ZM1 4.5H11V3.5H1V4.5Z" fill="#FF8402" />
                                        </svg>
                                    </div>
                                </div> : null
                        }

                            <div className='emp-info-slot1'>
                                <label>*Enter Full Name</label>
                                <input type='text' style={{ border: isError && (!empObj.empFullName || empObj.empFullName === '') ? '1px solid red' : null }} value={empObj.empFullName ? empObj.empFullName : ""} onChange={handleNameChange} disabled={selfData.role[0].roleLevel === 1 || selfInfo.role[0].roleLevel === 2 ? false : true} />
                            </div>
                            <div className='emp-info-slot2'>
                                <div className='slot-part'>
                                    <label>Employee Id</label>
                                    <input type='text' value={empObj.userId ? empObj.userId : ""} style={{ border: isError && (!empObj.userId || empObj.userId === '') ? '1px solid red' : null }} disabled={true} ></input>
                                </div>
                                <div className='slot-part'>
                                    <label>*Date of Joining</label>

                                    {/* <input type='date' style={{ border: isError && (empObj.empJoiningDate === '' || !empObj.empJoiningDate) ? '1px solid red' : null }} disabled={selfData.role[0].roleLevel === 1 || selfInfo.role[0].roleLevel === 2 ? false : true} value={empObj.empJoiningDate ? empObj.empJoiningDate : ""} onChange={handleJoiningDate} /> */}
                                    <div className='taskEdtSelectDateForAdd addEmpJoininCal' style={{ border: (!empObj.empJoiningDate || empObj.empJoiningDate === '') ? '1px solid red' : null }} onClick ={ selfData.role[0].roleLevel === 1 || selfInfo.role[0].roleLevel === 2 ? () => { setJoiningDateFlag(true) } : null}>
                                        <p style={{ fontFamily: 'Roboto', fontSize: '15px', }}>{joiningDate}</p>
                                        <div className='taskEdtSelectDateIcon'>
                                            <svg width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '20px', height: '20px' }}>
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.487 1.0466C1.15164 1.09171 0.958482 1.17629 0.817522 1.31737C0.676442 1.45833 0.591709 1.65164 0.546605 1.987C0.500533 2.32954 0.500002 2.78111 0.500002 3.41668V4.08335C0.500002 4.71892 0.500533 5.17048 0.546605 5.51303C0.591709 5.84839 0.676291 6.04154 0.817371 6.1825C0.958331 6.32358 1.15164 6.40832 1.487 6.45342C1.82954 6.49949 2.28111 6.50002 2.91668 6.50002H4.25002C4.88559 6.50002 5.33715 6.49949 5.6797 6.45342C6.01506 6.40832 6.20821 6.32373 6.34917 6.18265C6.49025 6.04169 6.57499 5.84839 6.62009 5.51303C6.66616 5.17048 6.66669 4.71892 6.66669 4.08335V3.41668C6.66669 2.78111 6.66616 2.32954 6.62009 1.987C6.57499 1.65164 6.4904 1.45848 6.34932 1.31752C6.20836 1.17644 6.01506 1.09171 5.6797 1.0466C5.33715 1.00053 4.88559 1 4.25002 1H2.91668C2.28111 1 1.82954 1.00053 1.487 1.0466ZM2.89787 0.5H4.26883C4.88137 0.499995 5.3666 0.499991 5.74635 0.551065C6.13708 0.603617 6.45338 0.714335 6.70273 0.963817C6.95231 1.21319 7.06307 1.52954 7.11563 1.92035C7.1667 2.30009 7.1667 2.78532 7.16669 3.39786V4.10216C7.1667 4.71471 7.1667 5.19993 7.11563 5.57968C7.06307 5.97045 6.95234 6.28677 6.7028 6.53613C6.45344 6.78567 6.13712 6.8964 5.74635 6.94896C5.3666 7.00003 4.88138 7.00003 4.26883 7.00003H2.89786C2.28532 7.00003 1.80009 7.00003 1.42035 6.94896C1.02954 6.8964 0.713191 6.78565 0.463817 6.53606C0.214335 6.28671 0.103617 5.97041 0.0510647 5.57968C-9.38777e-06 5.19993 -5.17778e-06 4.7147 1.07185e-07 4.10216V3.39787C-5.17778e-06 2.78532 -9.38777e-06 2.30009 0.0510647 1.92035C0.103622 1.52958 0.214357 1.21326 0.463892 0.963892C0.713255 0.714357 1.02958 0.603622 1.42035 0.551065C1.80009 0.499991 2.28532 0.499995 2.89787 0.5Z" fill="black" />
                                                <path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd" d="M1.91675 0C2.05483 0 2.16676 0.111929 2.16676 0.250001V0.750003C2.16676 0.888075 2.05483 1 1.91675 1C1.77868 1 1.66675 0.888075 1.66675 0.750003V0.250001C1.66675 0.111929 1.77868 0 1.91675 0ZM5.2501 0C5.38817 0 5.5001 0.111929 5.5001 0.250001V0.750003C5.5001 0.888075 5.38817 1 5.2501 1C5.11203 1 5.0001 0.888075 5.0001 0.750003V0.250001C5.0001 0.111929 5.11203 0 5.2501 0ZM0.166748 2.41668C0.166748 2.2786 0.278677 2.16668 0.416749 2.16668H6.75011C6.88818 2.16668 7.00011 2.2786 7.00011 2.41668C7.00011 2.55475 6.88818 2.66668 6.75011 2.66668H0.416749C0.278677 2.66668 0.166748 2.55475 0.166748 2.41668Z" fill="black" />
                                                <path d="M5.58327 5.08318C5.58327 5.17158 5.54815 5.25637 5.48564 5.31888C5.42312 5.38139 5.33834 5.41651 5.24993 5.41651C5.16153 5.41651 5.07674 5.38139 5.01423 5.31888C4.95172 5.25637 4.9166 5.17158 4.9166 5.08318C4.9166 4.99477 4.95172 4.90999 5.01423 4.84747C5.07674 4.78496 5.16153 4.74984 5.24993 4.74984C5.33834 4.74984 5.42312 4.78496 5.48564 4.84747C5.54815 4.90999 5.58327 4.99477 5.58327 5.08318ZM5.58327 3.74984C5.58327 3.83824 5.54815 3.92303 5.48564 3.98554C5.42312 4.04805 5.33834 4.08317 5.24993 4.08317C5.16153 4.08317 5.07674 4.04805 5.01423 3.98554C4.95172 3.92303 4.9166 3.83824 4.9166 3.74984C4.9166 3.66143 4.95172 3.57665 5.01423 3.51414C5.07674 3.45162 5.16153 3.4165 5.24993 3.4165C5.33834 3.4165 5.42312 3.45162 5.48564 3.51414C5.54815 3.57665 5.58327 3.66143 5.58327 3.74984ZM3.91659 5.08318C3.91659 5.17158 3.88148 5.25637 3.81896 5.31888C3.75645 5.38139 3.67167 5.41651 3.58326 5.41651C3.49485 5.41651 3.41007 5.38139 3.34756 5.31888C3.28504 5.25637 3.24993 5.17158 3.24993 5.08318C3.24993 4.99477 3.28504 4.90999 3.34756 4.84747C3.41007 4.78496 3.49485 4.74984 3.58326 4.74984C3.67167 4.74984 3.75645 4.78496 3.81896 4.84747C3.88148 4.90999 3.91659 4.99477 3.91659 5.08318ZM3.91659 3.74984C3.91659 3.83824 3.88148 3.92303 3.81896 3.98554C3.75645 4.04805 3.67167 4.08317 3.58326 4.08317C3.49485 4.08317 3.41007 4.04805 3.34756 3.98554C3.28504 3.92303 3.24993 3.83824 3.24993 3.74984C3.24993 3.66143 3.28504 3.57665 3.34756 3.51414C3.41007 3.45162 3.49485 3.4165 3.58326 3.4165C3.67167 3.4165 3.75645 3.45162 3.81896 3.51414C3.88148 3.57665 3.91659 3.66143 3.91659 3.74984ZM2.24992 5.08318C2.24992 5.17158 2.2148 5.25637 2.15229 5.31888C2.08978 5.38139 2.00499 5.41651 1.91659 5.41651C1.82818 5.41651 1.7434 5.38139 1.68088 5.31888C1.61837 5.25637 1.58325 5.17158 1.58325 5.08318C1.58325 4.99477 1.61837 4.90999 1.68088 4.84747C1.7434 4.78496 1.82818 4.74984 1.91659 4.74984C2.00499 4.74984 2.08978 4.78496 2.15229 4.84747C2.2148 4.90999 2.24992 4.99477 2.24992 5.08318ZM2.24992 3.74984C2.24992 3.83824 2.2148 3.92303 2.15229 3.98554C2.08978 4.04805 2.00499 4.08317 1.91659 4.08317C1.82818 4.08317 1.7434 4.04805 1.68088 3.98554C1.61837 3.92303 1.58325 3.83824 1.58325 3.74984C1.58325 3.66143 1.61837 3.57665 1.68088 3.51414C1.7434 3.45162 1.82818 3.4165 1.91659 3.4165C2.00499 3.4165 2.08978 3.45162 2.15229 3.51414C2.2148 3.57665 2.24992 3.66143 2.24992 3.74984Z" fill="black" />
                                            </svg>
                                        </div>
                                        {joiningDateFlag ?
                                            <div className='calender-holder-dashboard  cal-add-emp-join' ref={joiningDateRef}>
                                                <Calendar value={moment(joiningDate).toDate()} inline onChange={(e) => {
                                                    const formattedDate = moment(e.target.value).format("YYYY-MM-DD")
                                                    setJoiningDate(formattedDate)
                                                    setJoiningDateFlag(false)
                                                    setEmpObj({
                                                        ...empObj,
                                                        empJoiningDate: formattedDate,
                                                    });
                                                }} unstyled={false} />
                                            </div> : null
                                        }
                                    </div>

                                </div>
                            </div>
                            <div className='emp-info-slot2'>
                                <div className='slot-part'>
                                    <label>*Department</label>
                                    <Select options={departmentList} value={departmentName} style={{ border: isError && (!empObj.department.departmentName || empObj.department.departmentName === '') ? '1px solid red' : null }} placeholder="" onChange={handleDepartment} isSearchable={true} isMulti={false} className='empForm-select' isDisabled={selfData.role[0].roleLevel === 1 || selfInfo.role[0].roleLevel === 2 ? false : true} />
                                </div>
                                <div className='slot-part'>
                                    <label>*Designation</label>
                                    <Select options={designationList} value={designation} styles={{
                                        control: (provided, state) => ({
                                            ...provided,
                                            border: isError && (!empObj.designation || !empObj.designation.designation || empObj.designation.designation === '') ? '1px solid red' : provided.border,
                                            height: "5px"
                                        }),
                                    }} placeholder="" onChange={handleDesignation} isSearchable={true} isMulti={false} className='empForm-select' isDisabled={selfData.role[0].roleLevel === 1 || selfInfo.role[0].roleLevel === 2 ? false : true} />
                                </div>
                            </div>
                            <div className='emp-info-slot2'>
                                <div className='slot-part'>
                                    <label>Role</label>
                                    <Select options={roleList} placeholder="" value={role} style={{ border: isError && (!empObj.role || empObj.role.length === 0) ? '1px solid red' : null }} isSearchable={true} onChange={handleRoleChange} isMulti={false} className='empForm-select' isDisabled={selfData.role[0].roleLevel === 1 || selfInfo.role[0].roleLevel === 2 ? false : true} />
                                </div>
                                <div className='slot-part'>
                                    <label>*Reporting Authority</label>
                                    {/* <Select options={authorityList} placeholder="" value={authority} onChange={handleAuthority} isSearchable={true} isMulti={true} className='empForm-select' isDisabled={selfData.role[0].roleLevel === 1 || selfInfo.role[0].roleLevel === 2 ? false : true} /> */}
                                    {selfData.role[0].roleLevel !== 1 && selfData.role[0].roleLevel !== 2 ?
                                        (
                                            <div className='rptAutority'>
                                                <div className='retAuthScroll'>
                                                    {empObj && empObj.reportingAuthorities.length > 0 && empObj.reportingAuthorities.map((authObj) => (
                                                        <div className='repAuthDiv'>
                                                            <p>{authObj.empFullName}</p>
                                                            <svg width="16" height="216" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 1C3.91015 1 1 3.91015 1 7.5C1 11.0899 3.91015 14 7.5 14C11.0899 14 14 11.0899 14 7.5C14 3.91015 11.0899 1 7.5 1ZM0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5ZM4.12292 10.8745C3.85665 10.6083 3.85665 10.1765 4.12292 9.91028L6.5332 7.5L4.12292 5.08972C3.85665 4.82345 3.85665 4.39175 4.12292 4.12548C4.38919 3.85921 4.82089 3.85921 5.08716 4.12548L7.49744 6.53576L9.90834 4.12486C10.1746 3.8586 10.6063 3.8586 10.8726 4.12486C11.1388 4.39113 11.1388 4.82283 10.8726 5.0891L8.46168 7.5L10.8726 9.9109C11.1388 10.1772 11.1388 10.6089 10.8726 10.8751C10.6063 11.1414 10.1746 11.1414 9.90834 10.8751L7.49744 8.46424L5.08716 10.8745C4.82089 11.1408 4.38919 11.1408 4.12292 10.8745Z" fill="#fff" />
                                                            </svg>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )
                                        : (
                                            <Multiselect
                                                displayValue="key"
                                                onKeyPressFn={function noRefCheck() { }}
                                                onRemove={(e) => handleAuthority(e)}
                                                onSearch={function noRefCheck() { }}
                                                onSelect={(e) => handleAuthority(e)}
                                                options={authorityList}
                                                selectedValues={authority}
                                                disable={(selfData.role[0].roleLevel === 1 || selfInfo.role[0].roleLevel === 2) && empObj.role[0].roleId !== 1 ? false : true}
                                                placeholder={selfData.role[0].roleLevel === 1 || selfInfo.role[0].roleLevel === 2 ? '' : ""}
                                                style={{
                                                    chips: {
                                                        background: 'red'
                                                    },
                                                    searchBox: {
                                                        border: isError && (empObj.role[0].roleId !== 1 && (empObj.reportingAuthorities.length === 0 || authority.length === 0)) ? '1px solid red' : "1px solid #5a5959",
                                                        background: selfData.role[0].roleLevel !== 1 && selfInfo.role[0].roleLevel !== 2 ? "rgb(213 210 210 / 32%)" : null
                                                    },
                                                }}
                                            />
                                        )
                                    }

                                </div>
                            </div>

                            <div className='emp-info-slot2'>
                                <div className='slot-part'>
                                    <label>Enter mobile no. *(primary)</label>
                                    <input
                                        value={empObj.empMobile1 ? empObj.empMobile1 : ""}
                                        maxLength={10}
                                        style={{
                                            border: (!empObj.empMobile1 === '' || !validateIndianMobileNumber(empObj.empMobile1)) ? '1px solid red' : null
                                        }}
                                        onChange={handlePrimaryMobile}
                                        disabled={selfData.role[0].roleLevel === 1 || selfInfo.role[0].roleLevel === 2 ? false : false}
                                        type='number'
                                        pattern="[0-9]{10}"
                                        inputMode='numeric'
                                    />
                                </div>
                                <div className='slot-part'>
                                    <label>Enter mobile no.(Secondary)</label>
                                    <input value={empObj.empMobile2 ? empObj.empMobile2 : ""} maxLength={10} style={{ border: (empObj.empMobile2 !== "" && !validateIndianMobileNumber(empObj.empMobile2)) ? (empObj.empMobile2 ? '1px solid red' : null) : null }} onChange={handleSecondMobile} type='number'></input>
                                </div>
                            </div>
                            <div className='emp-info-slot2'>
                                <div className='slot-part'>
                                    <label>E-mail Id (ex.@biencaps.com)</label>
                                    <input value={empObj.empEmailOfficial ? empObj.empEmailOfficial : ""} id="officialEmail" onChange={handlePrimaryEmail} type='email' disabled={selfData.role[0].roleLevel === 1 || selfInfo.role[0].roleLevel === 2 ? false : true} />
                                </div>
                                <div className='slot-part'>
                                    <label>*E-mail Id*(personal)</label>
                                    <input value={empObj.empEmailPersonal ? empObj.empEmailPersonal : ""} id='persnolEmail' onChange={handleSecondaryEmail} type='email' style={{ border: isError && empObj.empEmailPersonal === '' ? '1px solid red' : null }}></input>
                                </div>
                            </div>
                            <div className='emp-info-slot1'>
                                <label>*Office Location</label>
                                <input value={empObj.empOfficeLocation ? empObj.empOfficeLocation : ""} style={{ border: isError && empObj.empOfficeLocation === "" ? "1px solid red" : null }} onChange={handleOfficeLocation} type='text' disabled={selfData.role[0].roleLevel === 1 || selfInfo.role[0].roleLevel === 2 ? false : true} />
                            </div>
                            <div className='emp-info-slot2'>
                                <div className='slot-part'>
                                    <label>Blood Group</label>
                                    <input value={empObj.empBloodGroup ? empObj.empBloodGroup : ""} onChange={handleBloodGroup} placeholder='-' type='text' maxLength={3}></input>
                                </div>
                                <div className='slot-part'>
                                    <label>Date of Birth</label>
                                    {/* <input value={empObj.empDOB ? empObj.empDOB : ""} onChange={handleDob} type='date'></input> */}
                                    {/* style={{ border: (!empObj.empDOB || empObj.empDOB === '') ? '1px solid red' : null }} */}
                                    <div className='taskEdtSelectDateForAdd addEmpJoininCal' onClick={() => { setDobDateFlag(true) }}>
                                        <p style={{ fontFamily: 'Roboto', fontSize: '15px', }}>{empObj.empDOB === null ? 'yyyy-mm-dd' : empObj.empDOB}</p>
                                        <div className='taskEdtSelectDateIcon'>
                                            <svg width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '20px', height: '20px' }}>
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.487 1.0466C1.15164 1.09171 0.958482 1.17629 0.817522 1.31737C0.676442 1.45833 0.591709 1.65164 0.546605 1.987C0.500533 2.32954 0.500002 2.78111 0.500002 3.41668V4.08335C0.500002 4.71892 0.500533 5.17048 0.546605 5.51303C0.591709 5.84839 0.676291 6.04154 0.817371 6.1825C0.958331 6.32358 1.15164 6.40832 1.487 6.45342C1.82954 6.49949 2.28111 6.50002 2.91668 6.50002H4.25002C4.88559 6.50002 5.33715 6.49949 5.6797 6.45342C6.01506 6.40832 6.20821 6.32373 6.34917 6.18265C6.49025 6.04169 6.57499 5.84839 6.62009 5.51303C6.66616 5.17048 6.66669 4.71892 6.66669 4.08335V3.41668C6.66669 2.78111 6.66616 2.32954 6.62009 1.987C6.57499 1.65164 6.4904 1.45848 6.34932 1.31752C6.20836 1.17644 6.01506 1.09171 5.6797 1.0466C5.33715 1.00053 4.88559 1 4.25002 1H2.91668C2.28111 1 1.82954 1.00053 1.487 1.0466ZM2.89787 0.5H4.26883C4.88137 0.499995 5.3666 0.499991 5.74635 0.551065C6.13708 0.603617 6.45338 0.714335 6.70273 0.963817C6.95231 1.21319 7.06307 1.52954 7.11563 1.92035C7.1667 2.30009 7.1667 2.78532 7.16669 3.39786V4.10216C7.1667 4.71471 7.1667 5.19993 7.11563 5.57968C7.06307 5.97045 6.95234 6.28677 6.7028 6.53613C6.45344 6.78567 6.13712 6.8964 5.74635 6.94896C5.3666 7.00003 4.88138 7.00003 4.26883 7.00003H2.89786C2.28532 7.00003 1.80009 7.00003 1.42035 6.94896C1.02954 6.8964 0.713191 6.78565 0.463817 6.53606C0.214335 6.28671 0.103617 5.97041 0.0510647 5.57968C-9.38777e-06 5.19993 -5.17778e-06 4.7147 1.07185e-07 4.10216V3.39787C-5.17778e-06 2.78532 -9.38777e-06 2.30009 0.0510647 1.92035C0.103622 1.52958 0.214357 1.21326 0.463892 0.963892C0.713255 0.714357 1.02958 0.603622 1.42035 0.551065C1.80009 0.499991 2.28532 0.499995 2.89787 0.5Z" fill="black" />
                                                <path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd" d="M1.91675 0C2.05483 0 2.16676 0.111929 2.16676 0.250001V0.750003C2.16676 0.888075 2.05483 1 1.91675 1C1.77868 1 1.66675 0.888075 1.66675 0.750003V0.250001C1.66675 0.111929 1.77868 0 1.91675 0ZM5.2501 0C5.38817 0 5.5001 0.111929 5.5001 0.250001V0.750003C5.5001 0.888075 5.38817 1 5.2501 1C5.11203 1 5.0001 0.888075 5.0001 0.750003V0.250001C5.0001 0.111929 5.11203 0 5.2501 0ZM0.166748 2.41668C0.166748 2.2786 0.278677 2.16668 0.416749 2.16668H6.75011C6.88818 2.16668 7.00011 2.2786 7.00011 2.41668C7.00011 2.55475 6.88818 2.66668 6.75011 2.66668H0.416749C0.278677 2.66668 0.166748 2.55475 0.166748 2.41668Z" fill="black" />
                                                <path d="M5.58327 5.08318C5.58327 5.17158 5.54815 5.25637 5.48564 5.31888C5.42312 5.38139 5.33834 5.41651 5.24993 5.41651C5.16153 5.41651 5.07674 5.38139 5.01423 5.31888C4.95172 5.25637 4.9166 5.17158 4.9166 5.08318C4.9166 4.99477 4.95172 4.90999 5.01423 4.84747C5.07674 4.78496 5.16153 4.74984 5.24993 4.74984C5.33834 4.74984 5.42312 4.78496 5.48564 4.84747C5.54815 4.90999 5.58327 4.99477 5.58327 5.08318ZM5.58327 3.74984C5.58327 3.83824 5.54815 3.92303 5.48564 3.98554C5.42312 4.04805 5.33834 4.08317 5.24993 4.08317C5.16153 4.08317 5.07674 4.04805 5.01423 3.98554C4.95172 3.92303 4.9166 3.83824 4.9166 3.74984C4.9166 3.66143 4.95172 3.57665 5.01423 3.51414C5.07674 3.45162 5.16153 3.4165 5.24993 3.4165C5.33834 3.4165 5.42312 3.45162 5.48564 3.51414C5.54815 3.57665 5.58327 3.66143 5.58327 3.74984ZM3.91659 5.08318C3.91659 5.17158 3.88148 5.25637 3.81896 5.31888C3.75645 5.38139 3.67167 5.41651 3.58326 5.41651C3.49485 5.41651 3.41007 5.38139 3.34756 5.31888C3.28504 5.25637 3.24993 5.17158 3.24993 5.08318C3.24993 4.99477 3.28504 4.90999 3.34756 4.84747C3.41007 4.78496 3.49485 4.74984 3.58326 4.74984C3.67167 4.74984 3.75645 4.78496 3.81896 4.84747C3.88148 4.90999 3.91659 4.99477 3.91659 5.08318ZM3.91659 3.74984C3.91659 3.83824 3.88148 3.92303 3.81896 3.98554C3.75645 4.04805 3.67167 4.08317 3.58326 4.08317C3.49485 4.08317 3.41007 4.04805 3.34756 3.98554C3.28504 3.92303 3.24993 3.83824 3.24993 3.74984C3.24993 3.66143 3.28504 3.57665 3.34756 3.51414C3.41007 3.45162 3.49485 3.4165 3.58326 3.4165C3.67167 3.4165 3.75645 3.45162 3.81896 3.51414C3.88148 3.57665 3.91659 3.66143 3.91659 3.74984ZM2.24992 5.08318C2.24992 5.17158 2.2148 5.25637 2.15229 5.31888C2.08978 5.38139 2.00499 5.41651 1.91659 5.41651C1.82818 5.41651 1.7434 5.38139 1.68088 5.31888C1.61837 5.25637 1.58325 5.17158 1.58325 5.08318C1.58325 4.99477 1.61837 4.90999 1.68088 4.84747C1.7434 4.78496 1.82818 4.74984 1.91659 4.74984C2.00499 4.74984 2.08978 4.78496 2.15229 4.84747C2.2148 4.90999 2.24992 4.99477 2.24992 5.08318ZM2.24992 3.74984C2.24992 3.83824 2.2148 3.92303 2.15229 3.98554C2.08978 4.04805 2.00499 4.08317 1.91659 4.08317C1.82818 4.08317 1.7434 4.04805 1.68088 3.98554C1.61837 3.92303 1.58325 3.83824 1.58325 3.74984C1.58325 3.66143 1.61837 3.57665 1.68088 3.51414C1.7434 3.45162 1.82818 3.4165 1.91659 3.4165C2.00499 3.4165 2.08978 3.45162 2.15229 3.51414C2.2148 3.57665 2.24992 3.66143 2.24992 3.74984Z" fill="black" />
                                            </svg>
                                        </div>
                                        {dobDateFlag ?
                                            <div className='calender-holder-dashboard  cal-add-emp-dob' ref={dobRef}>
                                                <Calendar value={empObj.empDOB ? empObj.empDOB : ""} inline onChange={(e) => {
                                                    const formattedDate = moment(e.target.value).format("YYYY-MM-DD")
                                                    setDobDate(formattedDate)
                                                    setDobDateFlag(false)
                                                    setIsChange(true)
                                                    setEmpObj({
                                                        ...empObj,
                                                        empDOB: formattedDate,
                                                    });
                                                }} unstyled={false} />
                                            </div> : null
                                        }
                                    </div>



                                </div>
                            </div>
                            <div>

                            </div>
                            <div className='slot-part'>
                                <label>*Enter RFID Card Number</label>
                                <input value={ cardId !== null ? (selfInfo.role[0].roleLevel === 1 || selfInfo.role[0].roleLevel === 2) ? cardId : '**********' : ""} style={{borderColor: (cardId === '' || cardId === null) ? 'red' : null}} disabled={ (selfInfo.role[0].role === 'ROLE_SUPERADMIN' || selfInfo.role[0].role === 'ROLE_ADMIN') ? false :  true} onChange={handleCardId} placeholder='-' type='text'></input>
                            </div>
                            <div className='emp-info-slot1'>
                                <label>Address</label>
                                <input value={empObj.empAddress ? empObj.empAddress : ""} onChange={handleAddress} type='text' />
                            </div>
                        </div>
                        <div className='form-bottom-buttons'>
                            <div className='AddEmpButtonEmpty' onClick={loaderBtn ? null : handleUpdateProfile}>{loaderBtn ? <div className='loaderBtn' /> : "Submit"}</div>
                            <div className='cancelBtn' onClick={handleCancelEdit}>Cancel</div>
                        </div>
                    </div>
                </div> :
                <div className='edit-employeefom-container' id='unloadElement' >
                    <div className="edit-employee-scroll-container">

                        {profileView ? <div className='profile-image-viewer' onClick={(e) => e.stopPropagation()}><img src={empInfo.empImg ? empInfo.empImg : profile} alt='profile-img' />
                        </div> : null}
                        <div className='dash-header'>
                            <div className='dash-header-container'>
                                <div className='dashHead-left-content'>
                                    <svg onClick={cancelFromEdit} width="22" height="22" style={{ marginLeft: '15px' }} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 1C3.91015 1 1 3.91015 1 7.5C1 11.0899 3.91015 14 7.5 14C11.0899 14 14 11.0899 14 7.5C14 3.91015 11.0899 1 7.5 1ZM0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5ZM4.12292 10.8745C3.85665 10.6083 3.85665 10.1765 4.12292 9.91028L6.5332 7.5L4.12292 5.08972C3.85665 4.82345 3.85665 4.39175 4.12292 4.12548C4.38919 3.85921 4.82089 3.85921 5.08716 4.12548L7.49744 6.53576L9.90834 4.12486C10.1746 3.8586 10.6063 3.8586 10.8726 4.12486C11.1388 4.39113 11.1388 4.82283 10.8726 5.0891L8.46168 7.5L10.8726 9.9109C11.1388 10.1772 11.1388 10.6089 10.8726 10.8751C10.6063 11.1414 10.1746 11.1414 9.90834 10.8751L7.49744 8.46424L5.08716 10.8745C4.82089 11.1408 4.38919 11.1408 4.12292 10.8745Z" fill="#263238" />
                                    </svg>
                                </div>
                                <div className='dashHead-right-content active'>
                                    <img className='profileImg' src={empObj.empImg ? empObj.empImg : profile} alt='/' />
                                    <p className='profileName'>{empObj.empFullName}</p>
                                    <svg width="32" height="33" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={handleNotificationDrawer}>
                                        <path fillRule="evenodd" clipRule="evenodd" d="M6.10305 0.0128568L6.08027 0.000677966C5.99553 0.000677966 5.91098 0.000677967 5.82725 0C5.50742 0.125153 5.38125 0.362911 5.41313 0.69835C5.41818 0.751721 5.4168 0.805763 5.41543 0.859865C5.41422 0.907526 5.413 0.955249 5.41618 1.00258C5.42228 1.09552 5.39515 1.13147 5.29543 1.14809C3.54023 1.44045 2.20187 2.9908 2.16863 4.77177C2.16199 5.12331 2.16308 5.47485 2.16418 5.82639C2.16471 5.99514 2.16523 6.16388 2.1649 6.33263C2.16388 6.93432 2.03805 7.5065 1.76129 8.04306C1.54355 8.46499 1.25254 8.82892 0.895392 9.14231C0.486015 9.50081 0.420555 10.056 0.735304 10.4603C0.946607 10.732 1.23219 10.8358 1.56932 10.8354C3.84334 10.8341 6.11737 10.8342 8.39139 10.8344L10.3382 10.8344L10.3527 10.8344C10.3817 10.8345 10.4106 10.8345 10.4396 10.8331C11.0145 10.8022 11.411 10.3528 11.3615 9.78232C11.3364 9.49471 11.176 9.28544 10.967 9.09788C10.2426 8.44735 9.82436 7.63538 9.76399 6.6623C9.74285 6.32142 9.74376 5.97907 9.74467 5.63665C9.74528 5.40772 9.74589 5.17875 9.73991 4.95018C9.73279 4.67681 9.72092 4.39835 9.66529 4.13176C9.33935 2.56615 8.16413 1.43129 6.58733 1.1447C6.51136 1.13079 6.49033 1.1006 6.49169 1.0287C6.49508 0.859794 6.4961 0.690209 6.49033 0.521303C6.48253 0.296773 6.36789 0.140754 6.16676 0.045787C6.14529 0.035552 6.12419 0.0242147 6.10305 0.0128568Z" fill="#FF8402" />
                                        <path fillRule="evenodd" clipRule="evenodd" d="M1.94262 0.600171C0.731109 1.84831 0.087704 3.34235 0.00528583 5.07822C0.00528583 5.11598 0.00396383 5.15389 0.0026421 5.19179C-0.000322873 5.27683 -0.00328649 5.36182 0.00867773 5.44487C0.0449689 5.69721 0.25695 5.88002 0.503865 5.89121C0.771131 5.90342 0.996678 5.743 1.05773 5.48455C1.07558 5.40811 1.07737 5.32708 1.07915 5.24693C1.07953 5.22965 1.07991 5.21238 1.08045 5.19524C1.1103 4.27948 1.33788 3.41799 1.77948 2.61416C2.03352 2.15153 2.34793 1.73401 2.7183 1.35855C2.85363 1.22153 2.92926 1.0611 2.89535 0.86608C2.85736 0.647994 2.73085 0.497063 2.51717 0.431604C2.29095 0.362413 2.10305 0.434996 1.94262 0.600171ZM11.9034 5.07589C11.9034 5.11271 11.9047 5.14972 11.9059 5.18674C11.9088 5.26842 11.9116 5.35017 11.9007 5.42999C11.8613 5.7193 11.6202 5.90754 11.3288 5.89092C11.0561 5.87532 10.8329 5.64671 10.8296 5.36249C10.8221 4.73198 10.7292 4.11706 10.5257 3.51944C10.2628 2.74783 9.85139 2.06543 9.29482 1.47052C9.27796 1.45245 9.26085 1.4346 9.24373 1.41673C9.20818 1.37963 9.17255 1.34245 9.13914 1.30331C8.94615 1.07743 8.96006 0.759964 9.16966 0.558497C9.37893 0.35737 9.70792 0.343802 9.91312 0.55714C10.1556 0.809821 10.3917 1.07234 10.5999 1.35317C11.4187 2.45717 11.843 3.70395 11.9034 5.07589ZM7.92396 11.3788H3.97468C4.11679 12.2183 4.94877 13.0597 6.07956 12.9967C6.97633 12.9465 7.92362 12.1175 7.92396 11.3788Z" fill="#263238" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div className='editEmp-container'>
                            <div className='emp-edit-container'>
                                <div className='emp-edit' onClick={() => setEdit(true)}>
                                    <svg width="12" height="12" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.30003 2.20612L7.5445 1.16119L4.68624 5.47621L6.44069 6.52011L9.30003 2.20612ZM4.41853 6.80306L4.37977 7.78343L5.29521 7.32432L6.14653 6.89852L4.45367 5.89033L4.41853 6.80306ZM9.76844 0.61864L8.85083 0.0716229C8.73985 0.0056241 8.60576 -0.0158966 8.47805 0.0117925C8.35033 0.0394816 8.23945 0.114114 8.16977 0.21928L7.80751 0.76458L9.56195 1.80917L9.92421 1.26455C10.0691 1.04478 10.0003 0.755308 9.76844 0.617953V0.61864ZM8.33206 8.79814C8.33206 8.89257 8.25056 8.96984 8.15093 8.96984H1.26792C1.21988 8.96984 1.17381 8.95175 1.13984 8.91955C1.10587 8.88735 1.08679 8.84368 1.08679 8.79814V2.27377C1.08679 2.22823 1.10587 2.18456 1.13984 2.15236C1.17381 2.12017 1.21988 2.10208 1.26792 2.10208H6.06574L6.74825 1.07191H1.26792C0.568754 1.07191 0 1.61103 0 2.27377V8.79814C0 9.46088 0.568754 10 1.26792 10H8.15093C8.8501 10 9.41886 9.46088 9.41886 8.79814V3.31664L8.33206 4.95666V8.79917V8.79814Z" fill="#FF8402" />
                                        <path d="M8.33207 8.7985C8.33207 8.89293 8.25056 8.97019 8.15093 8.97019H1.26792C1.21988 8.97019 1.17381 8.9521 1.13984 8.9199C1.10587 8.8877 1.08679 8.84403 1.08679 8.7985V2.27412C1.08679 2.22859 1.10587 2.18492 1.13984 2.15272C1.17381 2.12052 1.21988 2.10243 1.26792 2.10243H6.06574L6.74825 1.07227H1.26792C0.568754 1.07227 0 1.61138 0 2.27412V8.7985C0 9.46123 0.568754 10.0004 1.26792 10.0004H8.15093C8.8501 10.0004 9.41886 9.46123 9.41886 8.7985V3.31699L8.33207 4.95701V8.79953V8.7985Z" fill="#263238" />
                                    </svg>
                                    Edit Info
                                </div>
                                <div className='edit-tooltip'>Refresh your tab before edit</div>
                            </div>
                            <div className='profile-photo-container' onClick={(e) => e.stopPropagation()}>
                                <img src={empInfo.empImg ? empInfo.empImg : profile} onClick={() => setProfileView(true)} alt='profile-pic-main' />
                            </div>
                            <div className='active-status-dropdown'>
                                <input defaultValue={status} style={{ background: status === "INACTIVE" ? "rgba(202, 3, 3, 0.15)" : "rgba(1, 159, 55, 0.15)" }} disabled></input>
                            </div>
                        </div>
                        <div className='emp-form'>
                            <div className='emp-info-slot1'>
                                <label>*Enter Full Name</label>
                                <input type='text' value={empObj.empFullName ? empObj.empFullName : ""} disabled={true} />
                            </div>
                            <div className='emp-info-slot2'>
                                <div className='slot-part'>
                                    <label>Employee Id</label>
                                    <input type='text' value={empObj.userId ? empObj.userId : ""} disabled={true}></input>
                                </div>
                                <div className='slot-part'>
                                    <label>*Date of Joining</label>
                                    <input type='text' disabled={true} value={empObj.empJoiningDate ? empObj.empJoiningDate : ""} />
                                </div>
                            </div>
                            <div className='emp-info-slot2'>
                                <div className='slot-part'>
                                    <label>*Department</label>
                                    <input value={empInfo.department.departmentName} disabled={true} />
                                </div>
                                <div className='slot-part'>
                                    <label>*Designation</label>
                                    <input value={empInfo.designation.designation} disabled={true} />
                                </div>
                            </div>
                            <div className='emp-info-slot2'>
                                <div className='slot-part'>
                                    <label>Role</label>
                                    <input value={empInfo.role && empInfo.role.length > 0 ? empInfo.role[0].roleName : ""} type='text' disabled={true} />
                                </div>
                                <div className='slot-part reptAuthoDiv'>
                                    <label>*Reporting Authority</label>
                                    {/* <Select options={authorityList} placeholder="" value={authority} onChange={handleAuthority} isSearchable={true} isMulti={true} className='empForm-select' isDisabled={true} /> */}
                                    {/* <Multiselect
                                        displayValue="key"
                                        onKeyPressFn={function noRefCheck() { }}
                                        onRemove={(selectedOption) => {
                                        }}
                                        onSearch={function noRefCheck() { }}
                                        onSelect={(e) => handleAuthority(e)}
                                        options={authorityList}
                                        selectedValues={authority}
                                        disable={true}
                                        style={{
                                            chips: {
                                                background: 'red'
                                            },
                                            searchBox: {
                                                background: "rgb(213 210 210 / 32%)",
                                            },
                                        }}
                                        placeholder=''
                                    /> */}
                                    <div className='rptAutority'>
                                        <div className='retAuthScroll'>
                                            {empObj && empObj.reportingAuthorities.length > 0 && empObj.reportingAuthorities.map((authObj) => (
                                                <div className='repAuthDiv'>
                                                    <p>{authObj.empFullName}</p>
                                                    <svg width="16" height="216" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 1C3.91015 1 1 3.91015 1 7.5C1 11.0899 3.91015 14 7.5 14C11.0899 14 14 11.0899 14 7.5C14 3.91015 11.0899 1 7.5 1ZM0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5ZM4.12292 10.8745C3.85665 10.6083 3.85665 10.1765 4.12292 9.91028L6.5332 7.5L4.12292 5.08972C3.85665 4.82345 3.85665 4.39175 4.12292 4.12548C4.38919 3.85921 4.82089 3.85921 5.08716 4.12548L7.49744 6.53576L9.90834 4.12486C10.1746 3.8586 10.6063 3.8586 10.8726 4.12486C11.1388 4.39113 11.1388 4.82283 10.8726 5.0891L8.46168 7.5L10.8726 9.9109C11.1388 10.1772 11.1388 10.6089 10.8726 10.8751C10.6063 11.1414 10.1746 11.1414 9.90834 10.8751L7.49744 8.46424L5.08716 10.8745C4.82089 11.1408 4.38919 11.1408 4.12292 10.8745Z" fill="#fff" />
                                                    </svg>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='emp-info-slot2'>
                                <div className='slot-part'>
                                    <label>Enter mobile no. *(primary)</label>
                                    <input value={empInfo.empMobile1 ? empInfo.empMobile1 : ""} type='text' disabled={true}></input>
                                </div>
                                <div className='slot-part'>
                                    <label>(Secondary)</label>
                                    <input value={empInfo.empMobile2 ? empInfo.empMobile2 : ""} type='text' disabled={true}></input>
                                </div>
                            </div>
                            <div className='emp-info-slot2'>
                                <div className='slot-part'>
                                    <label>Enter E-mail Id (Official)</label>
                                    <input value={empInfo.empEmailOfficial ? empInfo.empEmailOfficial : ""} type='email' disabled={true}></input>
                                </div>
                                <div className='slot-part'>
                                    <label>E-mail Id *(personal)</label>
                                    <input value={empInfo.empEmailPersonal ? empInfo.empEmailPersonal : ""} type='email' disabled={true}></input>
                                </div>
                            </div>
                            <div className='emp-info-slot1'>
                                <label>*Office Location</label>
                                <input value={empInfo.empOfficeLocation ? empInfo.empOfficeLocation : ""} type='text' disabled={true} />
                            </div>
                            <div className='emp-info-slot2'>
                                <div className='slot-part'>
                                    <label>Blood Group</label>
                                    <input value={empInfo.empBloodGroup ? empInfo.empBloodGroup : "-"} type='text' disabled={true}></input>
                                </div>
                                <div className='slot-part'>
                                    <label>Date of Birth</label>
                                    <input value={empInfo.empDOB ? empInfo.empDOB : ""} type='date' disabled={true}></input>
                                </div>
                            </div>

                            <div className='emp-info-slot2'>
                                <div className='slot-part'>
                                    <label>*Enter RFID Card Number</label>
                                    <input value={cardId !== '' ? (selfInfo.role[0].roleLevel === 1 || selfInfo.role[0].roleLevel === 2) ? cardId : '**********' : ''} type='text' disabled={true}></input>
                                </div>
                            </div>

                            <div className='emp-info-slot1'>
                                <label>Address</label>
                                <input value={empInfo.empAddress ? empInfo.empAddress : ""} type='text' disabled={true} />
                            </div>
                        </div>
                    </div>
                </div>
            }
            {src && (
                <div className="canvas-holder" style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    zIndex: "590",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#0000009c",
                    flexDirection: "column"
                }}>
                    <div className='image-holder-crop'>

                        <ReactCrop
                            src={src}
                            crop={crop}
                            ruleOfThirds
                            onImageLoaded={onImageLoaded}
                            onComplete={onCropComplete}
                            onChange={onCropChange}
                            circularCrop
                        /></div>

                    <div className='canvas-button-holder'>
                        <div className='upload-img' onClick={() => {
                            setEmpObj({
                                ...empObj,
                                empImg: imgDataUrl
                            })
                            setSrc(null)
                        }
                        }>Upload</div>
                        <div className='upload-img' style={{ background: "rgba(232, 232, 232, 1)", color: '#000000' }} onClick={() => {
                            setTempImg(null)
                            setSrc(null)
                        }}>Cancel</div>
                    </div>

                </div>)
            }
        </div >
    )
}

export default EditEmpInfo


